<ion-header class="extendido">
  <ion-buttons>
    <ion-button (click)="closeModal()">
      <ion-back-button icon="arrow-back-outline" text="" defaultHref="login"></ion-back-button>
    </ion-button>
    <ion-title>{{'Selecione sua igreja' | translate}}</ion-title>
  </ion-buttons>
</ion-header>

<ion-content>
  <div class="gradient-extendido">
    <ion-searchbar
      show-cancel-button="never"
      (ionCancel)="onCancel()"
      placeholder="{{'Buscar Igreja' | translate}}"
      class="custom"
      [(ngModel)]="filtro.q"
      (ionInput)="onInput()"
    >
    </ion-searchbar>
  </div>

  <div class="title">
    <h1>{{'Selecione a igreja desejada' | translate}}</h1>
  </div>

  <ion-grid *ngFor="let i of instituicoes;" style="border-bottom: solid 1px #e7e7e7;">
    <ion-row (click)="selecionar(i);" class="ion-margin">
      <ion-col size="1" class="d-flex">
        <i class="fa-solid fa-church icon-cad"></i>
      </ion-col>

      <ion-col size="10" class="d-flex ion-justify-content-start">
        <h3 class="item-title">{{i.nome}}</h3>
      </ion-col>

      <ion-col size="1" class="d-flex">
        <ion-icon class="icon-arrow" name="arrow-forward-outline"></ion-icon>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
